import { useEffect, useState } from "react";
import { List, X } from "@phosphor-icons/react";

const NAV = [
  { label: "Work", href: "#portfolio" },
  { label: "Services", href: "#services" },
  { label: "Studio", href: "#about" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-24 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-3 group"
        >
          <span className="w-9 h-9 bg-[#E50914] flex items-center justify-center">
            <span className="font-display text-white text-lg leading-none">M</span>
          </span>
          <span className="font-display uppercase text-sm md:text-base tracking-[0.2em] text-white">
            Millionare Mir <span className="text-[#E50914]">Studio</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-300 hover:text-white transition-colors duration-200"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="header-cta-book"
          className="hidden md:inline-flex items-center gap-2 bg-[#E50914] hover:bg-[#B9090B] text-white px-5 py-3 font-mono text-xs uppercase tracking-[0.18em] transition-colors duration-200"
        >
          Book the studio
        </a>

        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} weight="bold" /> : <List size={24} weight="bold" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl"
        >
          <div className="flex flex-col px-6 py-6 gap-5">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className="font-mono text-sm uppercase tracking-[0.2em] text-zinc-300 hover:text-white"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-book"
              className="bg-[#E50914] hover:bg-[#B9090B] text-white px-5 py-3 font-mono text-xs uppercase tracking-[0.18em] w-fit"
            >
              Book the studio
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
